export var PostHogSurveyType;
(function (PostHogSurveyType) {
    PostHogSurveyType["API"] = "api";
    PostHogSurveyType["Popover"] = "popover";
})(PostHogSurveyType || (PostHogSurveyType = {}));
export var PostHogQuestionType;
(function (PostHogQuestionType) {
    PostHogQuestionType["Open"] = "open";
    PostHogQuestionType["Link"] = "link";
    PostHogQuestionType["Rating"] = "rating";
    PostHogQuestionType["SingleChoice"] = "single_choice";
    PostHogQuestionType["MultipleChoice"] = "multiple_choice";
})(PostHogQuestionType || (PostHogQuestionType = {}));
export var PostHogRatingDisplay;
(function (PostHogRatingDisplay) {
    PostHogRatingDisplay["Number"] = "number";
    PostHogRatingDisplay["Emoji"] = "emoji";
})(PostHogRatingDisplay || (PostHogRatingDisplay = {}));
